<template>
    <div class="title">
      <div class="dot"></div>
      <div class="left">{{ title }}</div>
      <div class="right" @click="handleClick">
        <span>{{ $t('app_more') }}</span
        ><i class="iconfont icon-icon_shouye_tiaozhuan"></i>
      </div>
    </div>
</template>
<script lang="ts" setup>
import { useThemeColor, useThemeColorWithAlpha } from '@/utils/theme'
import { useRouter } from 'vue-router'
const themeColor = useThemeColor()
const themeColorWithAlpha = useThemeColorWithAlpha(0.1)
const router = useRouter()
const props = defineProps<{
  title: string
  path: string
}>()
const emit = defineEmits<{(event: 'jump'): void;}>()
const handleClick = () => {
  router.push(props.path)
  emit('jump')
}
</script>
<style lang="less" scoped>
  .title {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    .dot {
      position: absolute;
      top: 0;
      left: 0;
      width: 17px;
      height: 17px;
      background: linear-gradient(to right, v-bind(themeColor), v-bind(themeColorWithAlpha));
      border-radius: 50%;
    }
    .left {
      font-size: 18px;
      color: #171921;
      font-weight: bold;
      margin-left: 10px;
    }
    .right {
      font-size: 14px;
      color: #999999;
    }
  }
</style>
